import axios from "utils/axios";
import type { CustomAxiosRequestConfig } from "@xt/xtbase";

const URL = "/sapi/v4/wallet/";
const USER_URL = "/uaapi/user/";

//获取充提-kyc
export function get_kycWalletLimit(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `withdraw/limits`, config);
}

// 快捷提币状态查询
export function get_fastWithdrawStatus(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `withdraw/fast-withdraw-status`, config);
}

//分页查询充值记录
export function get_depositHistory(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `deposit/history`, config);
}

//分页查询提币记录
export function get_withdrawHistory(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `withdraw/history`, config);
}

//获取用户充值地址
export function get_depositAddress(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `deposit/address`, config);
}

//检查fio域名获取状态
export function get_depositFioStatus(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `deposit/fio-status`, config);
}

//注册fio域名地址
export function get_depositFioRegister(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `deposit/fio-register`, config);
}

//提现
export function post_withdraw(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `withdraw`, null, config);
}

//根据业务id获取提现记录详情
export function get_withdrawBizId(bizId: string, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `withdraw/v2/${bizId}`, config);
}

// 根据提现id获取提现记录行情
export function get_widthDetailById(id: string) {
  return axios.get(URL + `withdraw/detail/v2/${id}`);
}

// 验证地址是否是内部地址
export function post_verifyWithdrawAddress(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `withdraw/address/check-type`, null, config);
}

//增加提现地址
export function post_withdrawAddress(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `withdraw/address`, null, config);
}

// 新增内部转账提现地址
export function post_innerTransferAddress(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `withdraw/inner-transfer/address`, null, config);
}

//编辑提现地址
export function put_withdrawAddressId(id, config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `withdraw/address/${id}`, null, config);
}

//删除提现地址
export function delete_withdrawAddressId(id, config?: CustomAxiosRequestConfig) {
  return axios.delete(URL + `withdraw/address/${id}`, config);
}

//提币地址匹配转账网络
export function post_withdrawAddressMatch(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `withdraw/address/match`, null, config);
}

//分页查看提币地址
export function get_withdrawAddresses(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `withdraw/addresses`, config);
}

//取消提现
export function delete_withdrawCancelId(id, config?: CustomAxiosRequestConfig) {
  return axios.delete(URL + `withdraw/cancel/${id}`, config);
}

//获取提现手续费
export function get_withdrawFee(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `withdraw/fee`, config);
}

//获取提币额度
export function get_withdrawLimitCurrencyId(currencyId, config?: CustomAxiosRequestConfig) {
  return axios.get(URL + `withdraw/limit/${currencyId}`, config);
}

// 快捷提币状态修改
export function post_fastWithdrawStatus(config?) {
  return axios.post(URL + `withdraw/fast-withdraw-status`, config);
}

// 快捷提币提示状态查询
export function get_withdrawTipsStatus(config) {
  return axios.get(URL + `withdraw/tip-status`, config);
}

// 设置不再提示
export function post_withdrawTipsStatus(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `withdraw/tip-status`, config);
}

// 检查用户信息是否存在
export function get_CheckUserInfo(config?: CustomAxiosRequestConfig) {
  return axios.get(USER_URL + `user/check/checkUserInfo`, config);
}

// 提现催促
export function put_withdrawUrge(id, config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `withdraw/withdraw-urge/${id}`, null, config);
}

// 获取用户充值配置
export function get_depositConfig(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + "deposit/config", config);
}

// 更新用户充值配置
export function put_depositConfig(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + "deposit/config", null, config);
}

export function post_depositSpeedApply(config?: CustomAxiosRequestConfig) {
  return axios.post(URL + `deposit-speed/apply`, null, config);
}

// 充值地址翻页
export function get_depositAddressPage(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + "deposit/addresses", config);
}

// 设置默认地址
export function put_depositDefaultAddress(config?: CustomAxiosRequestConfig, id?) {
  return axios.put(URL + `deposit/defaultAddress/${id}`, null, config);
}

// 编辑备注
export function put_depositRemark(config?: CustomAxiosRequestConfig) {
  return axios.put(URL + `deposit/remark`, null, config);
}

// 用户地址是否有过链上提币
export function get_hasWithdraw(config?: CustomAxiosRequestConfig) {
  return axios.get(URL + "withdraw/address/has-withdraw", config);
}
